import * as actionType from './ActionType';

const DEFAULT_STEP = -1;
const TOTAL_STEP = 5;
const initialState = {
  step: DEFAULT_STEP,
  totalStep: TOTAL_STEP,
  valueProgress: Math.ceil(((DEFAULT_STEP > 0 ? DEFAULT_STEP : 1) * 100) / (TOTAL_STEP + 1)),
  step00: null,
  step01: null,
  step02: null,
  step03: { owners: [], currentOwner: null, currentStep: 0 },
  step04: null,
  step05: null,
  ipInfo: null,
  payProvider: null,
  result: null,
  step03_01: null,
  step03_02: null
};

export function OnBoardAUSReducer(state = initialState, action) {
  switch (action.type) {
    case actionType.SET_IPINFO:
      return {
        ...state,
        ipInfo: action.payload.ipInfo
      };
    case actionType.SET_PAY_PROVIDER:
      return {
        ...state,
        payProvider: action.payload.payProvider
      };
    case actionType.CHANGE_PROGRESS:
      return {
        ...state,
        ...action.payload
      };
    case actionType.NEXT_STEP:
      const step = action.payload.step || state.step + 1;
      const nextStep = step > state.totalStep ? state.totalStep : step;
      return {
        ...state,
        step: nextStep,
        valueProgress: Math.ceil((nextStep * 100) / state.totalStep)
      };
    case actionType.PREV_STEP:
      const prevStep = state.step > 1 ? state.step - 1 : 0;
      return {
        ...state,
        step: prevStep,
        valueProgress: Math.ceil((prevStep * 100) / state.totalStep)
      };
    case actionType.SET_VALUE_STEP00:
      return {
        ...state,
        step00: {
          ...state.step00,
          ...action.payload
        }
      };
    case actionType.SET_VALUE_STEP01:
      return {
        ...state,
        step01: {
          ...state.step01,
          ...action.payload
        }
      };
    case actionType.SET_VALUE_STEP01_BUSINESS:
      return {
        ...state,
        step01: {
          ...state.step01,
          business: {
            ...state?.step01?.business,
            ...action.payload
          }
        }
      };
    case actionType.SET_VALUE_STEP02:
      return {
        ...state,
        step02: {
          ...state.step02,
          ...action.payload
        }
      };
    case actionType.SET_VALUE_STEP03:
      return {
        ...state,
        step03: {
          ...state.step03,
          ...action.payload
        }
      };
    case actionType.SET_VALUE_STEP04:
      return {
        ...state,
        step04: {
          ...state.step04,
          ...action.payload
        }
      };
    case actionType.SET_VALUE_STEP05:
      return {
        ...state,
        step05: {
          ...state.step05,
          ...action.payload
        }
      };
    case actionType.SET_VALUE_STEP06:
      return {
        ...state,
        step06: {
          ...state.step06,
          ...action.payload
        }
      };
    case actionType.SET_VALUE_STEP07:
      return {
        ...state,
        step07: {
          ...state.step07,
          ...action.payload
        }
      };
    case actionType.SET_ONBOARD_RESULT:
      return {
        ...state,
        result: action.payload
      };
    case actionType.SET_VALUE_STEP03_01:
      return {
        ...state,
        step03_01: {
          ...state.step03_01,
          ...action.payload
        }
      };
    case actionType.SET_VALUE_STEP03_02:
      return {
        ...state,
        step03_02: {
          ...state.step03_02,
          ...action.payload
        }
      };
    default:
      return state;
  }
}

export * from './Progress';
export * from './Step00';
export * from './Step01';
export * from './Step02';
export * from './Step03';
export * from './Step04';
export * from './Step05';
export * from './Step06';
export * from './Step07';
export * from './Result';
export * from './searchCompanyByName';
